import React from "react";
import { Provider } from "react-redux";
//
import AppStore from "./app-store";
import AppRoutes from "./app-routes";

const App = () => {

    return (
        <Provider store={AppStore}>
            <AppRoutes />
        </Provider>
    );
    
}

export default App;
